import React, { useState } from 'react';
import './BlogTable.css';

const BlogTable = ({ blogs, onDelete, onEdit, loading }) => {
  const [deletingId, setDeletingId] = useState(null);

  const handleDelete = async (blogId, blogTitle) => {
    if (window.confirm(`Are you sure you want to delete "${blogTitle}"?`)) {
      setDeletingId(blogId);
      try {
        await onDelete(blogId);
      } finally {
        setDeletingId(null);
      }
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const truncateText = (text, maxLength = 50) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  if (loading) {
    return <div className="table-loading">Loading blogs...</div>;
  }

  if (!blogs || blogs.length === 0) {
    return (
      <div className="no-blogs">
        <p>No blogs found</p>
      </div>
    );
  }

  return (
    <div className="blog-table-container">
      <div className="table-responsive">
        <table className="blog-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Title</th>
              <th>Author</th>
              <th>Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {blogs.map((blog) => (
              <tr key={blog.blog_id}>
                <td>{blog.blog_id}</td>
                <td className="blog-title-cell">
                  <div className="blog-title">{truncateText(blog.blog_title, 60)}</div>
                </td>
                <td>{blog.blog_by || 'Unknown'}</td>
                <td>{formatDate(blog.uploaded_date)}</td>
                <td>
                  <span className={`status-badge ${blog.display_status === '1' ? 'active' : 'inactive'}`}>
                    {blog.display_status === '1' ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td className="actions-cell">
                  <button
                    className="btn btn-edit"
                    onClick={() => onEdit(blog.blog_id)}
                    disabled={deletingId === blog.blog_id}
                    title="Edit blog"
                  >
                    Edit
                  </button>
                  <button
                    className="btn btn-delete"
                    onClick={() => handleDelete(blog.blog_id, blog.blog_title)}
                    disabled={deletingId === blog.blog_id}
                    title="Delete blog"
                  >
                    {deletingId === blog.blog_id ? 'Deleting...' : 'Delete'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BlogTable;
